module.exports = __webpack_public_path__ + "img/orderSummaryImage.420f73da.png";